/**
 * Venus Jewelry - Cart Widgets
 * Este archivo contiene las funciones globales para los widgets del carrito
 * Se carga con la página principal para asegurar disponibilidad
 */

console.log('📦 [venus-cart-widgets.js] Cargando...');

// ============================================
// FUNCIÓN: initCartDeliveryBadge
// Inicializa los badges de fechas de entrega
// ============================================
window.initCartDeliveryBadge = (function() {
  const monthsES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function formatDate(date) {
    const day = date.getDate();
    const month = monthsES[date.getMonth()];
    return `${day} ${month}`;
  }

  function formatDateRange(minDate, maxDate) {
    if (minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear()) {
      return `${minDate.getDate()} - ${maxDate.getDate()} ${monthsES[maxDate.getMonth()]}`;
    }
    return `${formatDate(minDate)} - ${formatDate(maxDate)}`;
  }

  function addBusinessDays(date, days) {
    let current = new Date(date);
    let added = 0;
    while (added < days) {
      current.setDate(current.getDate() + 1);
      const dayOfWeek = current.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        added++;
      }
    }
    return current;
  }

  function initBadge(badge) {
    const today = new Date();
    const minDelivery = addBusinessDays(today, 1);
    const maxDelivery = addBusinessDays(today, 3);

    const todayEl = badge.querySelector('[data-cart-delivery-today]');
    const estimateEl = badge.querySelector('[data-cart-delivery-estimate]');

    if (todayEl) todayEl.textContent = formatDate(today);
    if (estimateEl) estimateEl.textContent = formatDateRange(minDelivery, maxDelivery);

    badge.classList.add('is-in-view');
    console.log('✅ Badge de delivery inicializado');
  }

  function initAllBadges() {
    console.log('🔄 [initCartDeliveryBadge] Buscando badges...');
    const badges = document.querySelectorAll('.cart-delivery-badge');
    console.log('   Badges encontrados:', badges.length);
    badges.forEach(initBadge);
  }

  return initAllBadges;
})();

// ============================================
// FUNCIÓN: initCartDeliverySelector
// Inicializa el selector de método de envío
// ============================================
window.initCartDeliverySelector = (function() {
  var isInitializing = false;

  function updateEstimatedTotal(method) {
    console.log('🔍 Actualizando total estimado para método:', method);

    var subtotalElement = document.querySelector('[data-cart-subtotal]');
    if (!subtotalElement) {
      console.warn('⚠️ No se encontró elemento del subtotal');
      return;
    }

    var subtotalText = subtotalElement.textContent.trim();
    var subtotalMatch = subtotalText.match(/[\d,]+\.?\d*/);
    if (!subtotalMatch) {
      console.warn('⚠️ No se pudo extraer el valor del subtotal');
      return;
    }

    var cartTotalPesos = parseFloat(subtotalMatch[0].replace(/,/g, ''));
    var shippingCost = 0;

    if (method === 'delivery') {
      if (cartTotalPesos >= 700) {
        shippingCost = 0;
      } else if (cartTotalPesos >= 401) {
        shippingCost = 99;
      } else {
        shippingCost = 120;
      }
    }

    var estimatedTotal = cartTotalPesos + shippingCost;
    var formattedTotal = '$' + estimatedTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';

    var totalElement = document.querySelector('[data-cart-total]');
    if (totalElement) {
      totalElement.textContent = formattedTotal;
      console.log('✅ Total actualizado:', formattedTotal);
    }

    var shippingElement = document.querySelector('.cart__shipping-amount');
    if (shippingElement) {
      if (method === 'pickup' || shippingCost === 0) {
        shippingElement.innerHTML = '<span class="cart__free-badge">GRATIS</span>';
        shippingElement.classList.add('cart__shipping-amount--free');
      } else {
        shippingElement.classList.remove('cart__shipping-amount--free');
        var formattedShipping = '$' + shippingCost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
        shippingElement.textContent = formattedShipping;
      }
    }
  }

  function updateSelection(method) {
    var currentOptions = document.querySelectorAll('.vj-delivery-option');
    var currentPanels = document.querySelectorAll('.vj-delivery-details__panel');

    currentOptions.forEach(function(option) {
      var optionMethod = option.getAttribute('data-method');
      var isSelected = optionMethod === method;

      if (isSelected) {
        option.classList.add('vj-delivery-option--active');
        option.setAttribute('aria-pressed', 'true');
      } else {
        option.classList.remove('vj-delivery-option--active');
        option.setAttribute('aria-pressed', 'false');
      }
    });

    currentPanels.forEach(function(panel) {
      var panelMethod = panel.getAttribute('data-panel');
      if (panelMethod === method) {
        panel.classList.add('vj-delivery-details__panel--active');
      } else {
        panel.classList.remove('vj-delivery-details__panel--active');
      }
    });

    localStorage.setItem('vj-delivery-method', method);
    updateEstimatedTotal(method);
    console.log('✅ Método de envío seleccionado:', method);
  }

  function attachListeners(options) {
    options.forEach(function(option) {
      if (option.getAttribute('data-listener-attached') === 'true') {
        return; // Ya tiene listener
      }

      option.setAttribute('data-listener-attached', 'true');

      option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var method = this.getAttribute('data-method');
        console.log('🖱️ Click en opción:', method);
        updateSelection(method);
      });

      option.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var method = this.getAttribute('data-method');
          updateSelection(method);
        }
      });
    });
  }

  function initDeliverySelector() {
    if (isInitializing) {
      console.log('⏳ Inicialización en progreso, ignorando...');
      return;
    }
    isInitializing = true;

    console.log('🔄 [initCartDeliverySelector] Inicializando...');
    var savedMethod = localStorage.getItem('vj-delivery-method') || 'delivery';
    var options = document.querySelectorAll('.vj-delivery-option');

    if (options.length === 0) {
      console.log('⏳ No hay opciones de delivery aún');
      isInitializing = false;
      return;
    }

    console.log('   Opciones encontradas:', options.length);

    // Aplicar selección guardada
    updateSelection(savedMethod);

    // Limpiar y re-adjuntar listeners clonando nodos
    options.forEach(function(option) {
      var newOption = option.cloneNode(true);
      newOption.removeAttribute('data-listener-attached');
      if (option.parentNode) {
        option.parentNode.replaceChild(newOption, option);
      }
    });

    // Obtener las nuevas opciones y adjuntar listeners
    var freshOptions = document.querySelectorAll('.vj-delivery-option');
    attachListeners(freshOptions);

    // Forzar actualización del total
    setTimeout(function() {
      updateEstimatedTotal(savedMethod);
    }, 100);

    console.log('✅ Delivery selector inicializado con', freshOptions.length, 'opciones');
    isInitializing = false;
  }

  return initDeliverySelector;
})();

// ============================================
// FUNCIÓN: vjUpdateShippingBar
// Actualiza la barra de envío gratis
// ============================================
window.vjUpdateShippingBar = function(cartTotalCents) {
  var freeThreshold = 70000;
  var partialThreshold = 40100;
  var total = cartTotalCents;
  var totalPesos = total / 100;

  var pct;
  if (totalPesos >= 401) {
    var progressStart = 401;
    var progressRange = 700 - 401;
    var progressCurrent = totalPesos - progressStart;
    pct = (progressCurrent / progressRange) * 50 + 50;
  } else {
    pct = (totalPesos / 401) * 50;
  }
  pct = Math.min(pct, 100);

  var msg = document.getElementById('vj-shipping-msg');
  var fill = document.getElementById('vj-shipping-fill');
  var bar = document.getElementById('vj-shipping-bar');
  var milestone1 = document.querySelector('.vj-shipping-milestone--first');
  var milestone2 = document.querySelector('.vj-shipping-milestone--second');

  // VJ: mismos íconos/estructura que el markup de venus-cart-enhancements.liquid
  // (position: 'top'), para que si esta función llega a usarse no rompa el diseño.
  var truckIcon =
    '<span class="vj-shipping-bar__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg></span>';
  var checkIcon =
    '<span class="vj-shipping-bar__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>';
  var checkIconSmall =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  if (msg && fill) {
    if (total >= freeThreshold) {
      msg.innerHTML = checkIcon + '¡Desbloqueaste el envío <strong>GRATIS</strong>!';
      msg.classList.add('vj-shipping-bar__msg--success');
      fill.classList.add('vj-shipping-bar__fill--complete');
      if (bar) bar.classList.add('vj-shipping-bar--complete');
    } else if (totalPesos >= 401) {
      var remainingForFree = Math.ceil((freeThreshold - total) / 100);
      msg.innerHTML = truckIcon + 'Te faltan <strong>$' + remainingForFree + '</strong> para envío <strong>GRATIS</strong>';
      msg.classList.remove('vj-shipping-bar__msg--success');
      fill.classList.remove('vj-shipping-bar__fill--complete');
      if (bar) bar.classList.remove('vj-shipping-bar--complete');
    } else {
      var remainingForPartial = Math.ceil((partialThreshold - total) / 100);
      msg.innerHTML = truckIcon + 'Te faltan <strong>$' + remainingForPartial + '</strong> para envío <strong>$99</strong>';
      msg.classList.remove('vj-shipping-bar__msg--success');
      fill.classList.remove('vj-shipping-bar__fill--complete');
      if (bar) bar.classList.remove('vj-shipping-bar--complete');
    }
    fill.style.width = pct + '%';
  }

  if (milestone1) {
    var milestone1Reached = totalPesos >= 401;
    milestone1.classList.toggle('vj-shipping-milestone--reached', milestone1Reached);
    milestone1.innerHTML = (milestone1Reached ? checkIconSmall : '') + '<span class="vj-shipping-milestone-label">$401</span>';
  }
  if (milestone2) {
    var milestone2Reached = total >= freeThreshold;
    milestone2.classList.toggle('vj-shipping-milestone--reached', milestone2Reached);
    milestone2.innerHTML = (milestone2Reached ? checkIconSmall : '') + '<span class="vj-shipping-milestone-label">$700</span>';
  }
};

console.log('✅ [venus-cart-widgets.js] Funciones globales registradas');
console.log('   - window.initCartDeliveryBadge:', typeof window.initCartDeliveryBadge);
console.log('   - window.initCartDeliverySelector:', typeof window.initCartDeliverySelector);
console.log('   - window.vjUpdateShippingBar:', typeof window.vjUpdateShippingBar);
